import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

import './WelcomeDialog.css'

function WelcomeDialog(props) {
    const { onClose, open } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog onClose={handleClose} open={open} sx={{
            '& .MuiPaper-root': {
                padding: '10px',
                color: 'white',
                backgroundColor: '#1d2027'
            },
        }}>
            <DialogTitle sx={{
                textAlign: 'center',
                padding: '5px 24px'
            }}>Welcome to the Exoplanets Visualizer!</DialogTitle>
            <p>This web app displays data from the <a href='https://exoplanetarchive.ipac.caltech.edu/'>NASA Exoplanet Archive</a>, rendering it in 3D space and sporting a variety of customization parameters. The app is inspired by NASA's <a href='https://eyes.nasa.gov/apps/exo/#/'>"Eyes on Exoplanets"</a>, which functions similarly.</p>
            <p>There are more features planned for the future, including planet visualization, a "Size By" axis, and showing stars from other datasets (that are not known to have exoplanets).</p><br />
            <i>Data last pulled from the archive in November 2024.</i><br />
            <Button variant="contained" sx={{ width: '110px', alignSelf: 'center', backgroundColor: 'white', color:'black' }} onClick={handleClose}>Let's Go!</Button>
        </Dialog>
    )
};
export default WelcomeDialog;